import axios from 'axios';

export const clientesApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/clients`,
    headers: {
        'Content-Type': 'application/json'
    }
})